<template>
  <div class="activityManage">
    <div class="activityManageBox">
      <el-row>
        <el-col :span="20">数据筛选</el-col>
        <el-col :span="4">
          <el-button type="success" round icon="el-icon-check" size="small" @click="searchData()">确 认</el-button>
          <el-button type="info" round icon="el-icon-refresh-left" size="small" @click="clearFilter()">重 置</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="30" class="filter">
        <el-col :span="8">
          <span class="label">检查ID</span>
          <el-input
            v-model="filterData.resultID"
            placeholder="请输入检查ID"
            style="width: 100%"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <span class="label">名称</span>
          <el-input
            v-model="filterData.name"
            placeholder="请输入名称"
            style="width: 100%"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <span class="label">行动状态</span>
          <el-select
            class="area"
            v-model="filterData.state"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in stateList"
              :key="item.key"
              :label="item.key"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="30" class="filter">
        <el-col :span="8">
          <span class="label">日期</span>
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="filterData.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 100%"
            :clearable="false"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="8">
          <span class="label">区域</span>
          <el-select
            class="region"
            v-model="filterData.region"
            placeholder="请选择"
            style="width: 100%"
            multiple
            @change="changeFilter"
          >
            <el-option
              v-for="item in areaList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="label">省份</span>
          <el-select
            class="region"
            v-model="filterData.province"
            placeholder="请选择"
            style="width: 100%"
            multiple
            @change="changeFilter"
          >
            <el-option
              v-for="item in provinceList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="30" class="filter">
        <el-col :span="8">
          <span class="label">城市</span>
          <el-select
            class="region"
            v-model="filterData.city"
            placeholder="请选择"
            style="width: 100%"
            multiple
            @change="changeFilter"
          >
            <el-option
              v-for="item in cityList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="8">
          <span class="label">cluster Name</span>
          <el-select
            class="region"
            v-model="filterData.clusterName"
            placeholder="请选择"
            style="width: 100%"
            multiple
            @change="changeFilter"
          >
            <el-option
              v-for="item in clusterList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-col> -->
        <el-col :span="8">
          <span class="label">门店类型</span>
          <el-select
            class="region"
            v-model="filterData.concept"
            placeholder="请选择"
            style="width: 100%"
            multiple
            @change="changeFilter"
          >
            <el-option
              v-for="item in conceptList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="8">
          <span class="label">客户</span>
          <el-select
            class="region"
            v-model="filterData.reseller"
            placeholder="请选择"
            style="width: 100%"
            multiple
            @change="changeFilter"
          >
            <el-option
              v-for="item in customerList"
              :key="item.no"
              :label="item.name"
              :value="item.no">
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-row :gutter="30" class="filter">

        <el-col :span="8">
          <span class="label">门店编号</span>
          <el-input
            v-model="filterData.posId"
            placeholder="请输入门店编号"
            style="width: 100%"
          ></el-input>
        </el-col>
        <el-col :span="8">
          <span class="label">门店名</span>
          <span @click="onChooseDoor">
            <el-input
              readonly
              v-model="filterData.doorName"
              placeholder="请输入门店名"
              style="width: 100%"
            ></el-input>
          </span>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="30" class="filter">
        <el-col :span="8">
          <span class="label">Hub标记</span>
          <el-select
            class="area"
            v-model="filterData.hub"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in hubList"
              :key="item.key"
              :label="item.key"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row> -->


      <el-divider></el-divider>

      <el-row>
        <el-col :span="18">数据列表</el-col>
        <el-col :span="6">
          <el-button
            plain
            round
            icon="el-icon-download"
            size="small"
            style="color: #67C23A"
            @click="exportFile()"
          >
            导 出
          </el-button>

          <el-button plain round size="small" style="color: #67C23A" @click="exportImages" v-if="progress === 1 || progress === 3">
            图片/视频下载
          </el-button>
          <el-button plain round size="small" style="color: #67C23A" disabled v-if="progress === 2">
            正在处理...
          </el-button>

          <el-button
            plain
            round
            icon="el-icon-document"
            size="small"
            style="color: #67C23A"
            @click="openDownloadList"
          >
            下载列表
          </el-button>
        </el-col>
      </el-row>

      <el-table
        style="width: 100%; margin-top: 20px"
        fit
        stripe
        :data="tableData"
        v-loading="tableLoading"
        border
      >
        <el-table-column
          prop="resultID"
          label="检查ID"
          width="80"
        ></el-table-column>

        <el-table-column
          prop="name"
          label="名称"
          width="200"
        ></el-table-column>

        <el-table-column
          prop="createStr"
          label="创建时间"
          width="110"
        ></el-table-column>

        <el-table-column
          prop="regionName"
          label="区域"
          width="90"
        ></el-table-column>

        <el-table-column
          prop="doorName"
          label="门店名称"
          width="220"
        ></el-table-column>

        <el-table-column
          prop="accountName"
          label="填写人"
          width="90"
        ></el-table-column>

        <el-table-column
          prop="depict"
          label="描述"
          width="200"
        ></el-table-column>

        <el-table-column
          prop="endStr"
          label="截止时间"
          width="110"
        ></el-table-column>

        <el-table-column
          prop="stateStr"
          label="行动状态"
          width="90"
        ></el-table-column>

        <el-table-column
          prop="cityName"
          label="城市"
          width="90"
        ></el-table-column>

        <!-- <el-table-column
          prop="door.clusterName"
          label="Cluster Name"
          width="140"
        ></el-table-column> -->

        <!-- <el-table-column
          prop="door.concept"
          label="门店类型"
          width="140"
        ></el-table-column>

        <el-table-column
          prop="door.clusterGroup"
          label="Cluster Group"
          width="140"
        ></el-table-column>

        <el-table-column
          prop="door.tzGroup"
          label="Tz Group"
          width="140"
        ></el-table-column>

        <el-table-column
          prop="door.format"
          label="Format"
          width="140"
        ></el-table-column>

        <el-table-column
          prop="door.hub"
          label="Hub标记"
          :formatter="fmtHub"
          width="90"
        ></el-table-column> -->

        <el-table-column label="操作" width="130" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="seeDetail(scope.row.id)"
            >查看行动详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <footer>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="tableConfig.current"
          :total="total"
        ></el-pagination>
      </footer>
    </div>
    <el-dialog
      title="行动详情"
      :visible.sync="detailDialogVisible"
      width="70%"
    >
      <div>
        <div class="detailBox">
          <el-form ref="form" :model="activityDetail" label-width="100px">
            <el-form-item label="门店名称:">
              {{ activityDetail.doorName }}
            </el-form-item>
            <el-form-item label="行动名称:">
              {{ activityDetail.activityName }}
            </el-form-item>
            <el-form-item label="状态:">
              {{ activityDetail.stateStr }}
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item label="描述:">
              {{ activityDetail.desc }}
            </el-form-item>
            <el-form-item label="图片:">
              <div class="images">
                <img :src="pic" alt="" v-for="(pic, index) in activityDetail.images" :key="index">
              </div>
            </el-form-item>
            <el-form-item label="视频:">
              <video v-if="activityDetail.video" width="300" :src="activityDetail.video" controls ref="videoPlayer1">
                Your browser does not support the video tag.
              </video>
            </el-form-item>

            <el-card style="margin-top: 20px">
              <div v-for="(reply, index) in activityDetail.replys" :key="index">
                <el-form-item label="门店响应:">
                  {{ reply.content }}
                </el-form-item>
                <el-form-item label="图片:">
                  <div class="images">
                    <img :src="pic" alt="" v-for="(pic, j) in reply.images" :key="j">
                  </div>
                </el-form-item>
                <el-form-item label="视频:">
                  <video v-if="reply.video" width="300" :src="reply.video" controls>
                    Your browser does not support the video tag.
                  </video>
                </el-form-item>
              </div>

            </el-card>

          </el-form>
        </div>
        <footer style="text-align: center">
          <el-button type="success" size="small" @click="detailDialogVisible = false">关闭</el-button>
        </footer>
      </div>
    </el-dialog>
    <el-dialog
      title="预约下载列表"
      :visible.sync="downloadDialog"
      width="60%"
      center>
      <div class="downloadList">
        <el-table :data="downloadList">
          <el-table-column property="name" label="预约人" width="130" ></el-table-column>
          <el-table-column property="exportTime" label="预约时间" width="170" ></el-table-column>
          <el-table-column property="condition" label="查询条件" ></el-table-column>
          <el-table-column property="status" label="状态" width="75" :show-overflow-tooltip="true" :formatter="statusFormatter">
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 'ok'"
                type="text"
                size="mini"
                @click="downloadData(scope.row.urls)"
              >下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <footer>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="downloadCurrentChange"
            :current-page="downloadTableConfig.current"
            :total="downloadTotal"
          ></el-pagination>
        </footer>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downloadDialog = false">关闭</el-button>
      </span>
    </el-dialog>
    <pickDoor v-model="filterData.posId" :filterForm="this.filterData" ref='PickDoor'/>
  </div>
</template>
<script>

// 获取当月第一天
function getFirstDayOfMonth() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}-01`;
}

// 获取当月最后一天
function getLastDayOfMonth() {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const lastDay = new Date(year, month, 0).getDate();
  return `${year}-${String(month).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;
}

console.log('当月第一天:', getFirstDayOfMonth());
console.log('当月最后一天:', getLastDayOfMonth());
import md5 from "md5";
import _ from "lodash";
import PickDoor from '../../components/pickDoor'

export default {
  name: "activityManage",
  data() {
    return {
      detailDialogVisible: false, //行动详情弹窗
      filterData: {},
      initialFilterData: {
        resultID: '', //检查ID
        name: '',
        state: '',
        province: [],
        date: [getFirstDayOfMonth(), getLastDayOfMonth()],
        start: '',
        end: '',
        region: [],
        city: [],
        clusterName: [],
        concept: [],
        cityTier: [],
        tzGroup: [],
        format: [],
        reseller: [],
        posId: "",
        posIds: [],
        doorName: "",
        hub: ''
      },
      questionList: [],
      areaList: [],
      provinceList: [],
      cityList: [],
      clusterList: [],
      conceptList: [],
      tierList: [],
      groupList: [],
      formatList: [],
      customerList: [],
      posidList: [],
      storeNameList: [],
      stateList: [
        {
          key: '未响应',
          value: 1
        },
        {
          key: '待审核',
          value: 2
        },
        {
          key: '未合格',
          value: 3
        },
        {
          key: '已合格',
          value: 4
        },
      ],
      hubList: [
        {
          key: '是',
          value: true
        },
        {
          key: '否',
          value: false
        },
      ],
      tableData: null, // 列表
      total: 10, // 总数量
      tableConfig: {
        "size": 10, // 每页数量
        "current": 1, // 当前页码
      },
      tableLoading: false,
      activityDetail: {
        doorName: '', //门店名称
        activityName: '', //行动名称
        stateStr: '', //状态
        desc: '',
        images: [],
        video: '',
        replys: [],
      },
      downloadDialog: false,
      downloadList: [], //下载列表
      downloadTotal: 0, // 下载列表总数量
      downloadTableConfig: {
        size: 10, // 每页数量
        current: 1, // 当前页码
      },
      queryProcess: null, //轮询预约下载进度
      progress: 1, //1预约下载 2正在处理
    }
  },
  async getOptions() {
    let res = await axios.post(oprReqUrl+"door/linkage", _.omit(this.reportForm, ['date']));
    if (res.data.code === 200) {
      const dataList = res.data.data;
      this.areaList = dataList.region || [];
      this.cityList = dataList.city || [];
      this.conceptList = dataList.concept || [];
      this.customerList = dataList.reseller || [];
      this.provinceList = dataList.province || [];
      this.clusterList = dataList.clusterName || [];
      this.tierList = dataList.cityTier || [];
      this.groupList = dataList.tzGroup || [];
      this.formatList = dataList.format || [];
      this.posidList = dataList.posid || [];
      this.storeNameList = dataList.door || [];
    }
  },
  changeFilter() {
    this.getOptions();
  },
  mounted() {
    this.clearFilter();
    this.getData();
    this.getOptions();
    // this.initDate();
  },
  components: {
    pickDoor: PickDoor,
  },
  methods: {
    initDate(){
      this.initialFilterData.date = [getFirstDayOfMonth(), getLastDayOfMonth()]
    },
    onChooseDoor: function () {
      this.$refs.PickDoor.openDialog()
    },
    async getOptions() {
      let res = await axios.post(oprReqUrl+"door/linkage", _.omit(this.filterData, ['date', 'name', 'state', 'posId']));
      if (res.data.code === 200) {
        const dataList = res.data.data;
        this.areaList = dataList.region || [];
        this.cityList = dataList.city || [];
        this.conceptList = dataList.concept || [];
        this.customerList = dataList.reseller || [];
        this.provinceList = dataList.province || [];
        this.clusterList = dataList.clusterName || [];
        this.tierList = dataList.cityTier || [];
        this.groupList = dataList.tzGroup || [];
        this.formatList = dataList.format || [];
        this.posidList = dataList.posid || [];
        this.storeNameList = dataList.door || [];
      }
    },
    changeFilter() {
      this.getOptions();
    },
    searchData() {
      this.tableConfig.current = 1;
      this.getData();
    },
    async getData() {
      // 获取列表
      this.tableLoading = true;
      this.filterData.start = this.filterData.date[0]
      this.filterData.end = this.filterData.date[1]
      this.filterData.posIds = this.filterData.posId ? this.filterData.posId.split(',') : []
      const params = _.assign(this.tableConfig, this.filterData )
      let res = await axios.post(oprReqUrl+"action/list", params);
      if (res.data.code === 200) {
        this.tableData = res.data.data.list
        this.total = res.data.data.total
        console.log(this.tableData)
        //this.tableData = res.data.doorList.list || [];
        //this.total = res.data.doorList.total;
      }
      this.tableLoading = false;
    },
    currentChange(index) {
      // 分页
      this.tableConfig.current = index;
      this.getData();
    },
    clearFilter() {
      this.filterData = _.cloneDeep(this.initialFilterData);
      this.getOptions()
    },
    fmtHub(row, column, cellValue, index) {
      if (cellValue === true) {
        return "Hub";
      } else if (cellValue === false) {
        return "非 Hub";
      }
    },
    async exportFile() {
      const params = _.assign(this.tableConfig, this.filterData)
      let response = await axios({
        method: 'post',
        responseType: "blob",
        url: oprReqUrl+'action/export',
        data: params
      });

      let fileName = response.headers["content-disposition"].split("''")[1];
      if(!fileName) {
        fileName = response.headers["content-disposition"].split("=")[1];
      }
      fileName = decodeURI(fileName);

      let res = response.data;
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
      return { data: response, fileName };
    },

    //todo: 查看行动详情
    async seeDetail(id) {
      this.activityDetail = {}
      this.detailDialogVisible = true
      let res = await axios.post(oprReqUrl+"api/actiondetail", {id});
      console.log('详情')
      if (res.data.code === 200) {
        console.log('详情', res.data)
        let detailData = res.data.data
        this.activityDetail.doorName = detailData.door.doorName
        this.activityDetail.activityName = detailData.name
        this.activityDetail.stateStr = detailData.stateStr
        this.activityDetail.desc = detailData.depict
        this.activityDetail.images = detailData.images
        this.activityDetail.video = detailData.video
        this.activityDetail.replys = detailData.replys
        this.activityDetail = _.cloneDeep(this.activityDetail)
      }
    },

    getStatusText(list, status) {
      let result = _.find(list, (a) => a.value === status)
      return result.key
    },

    async openDownloadList() {
      this.downloadDialog = true
      let res = await axios.post(oprReqUrl+"/action/exportlist", this.downloadTableConfig);
      if (res.data.code === 200) {
        console.log('res.data', res.data)
        this.downloadList = res.data.data.records
        this.downloadTotal = res.data.data.total
      }
    },

    downloadCurrentChange(index) {
      // 分页
      this.downloadTableConfig.current = index;
      this.openDownloadList()
    },

    // 下载具体的文件
    downloadData(urls) {
      _.each(urls, (file) => {
        window.open(file)
      })
    },

    // 预约下载
    async exportImages() {
      this.$confirm("确认后开始打包，打包完成后请进入下载列表进行下载", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const params = this.getParams()
          let res = await axios.post(oprReqUrl+"/action/exportImage", params);
          if (res.data.code === 200) {
            // 正在处理...
            this.$message.success('预约成功');
            // this.changeProgress()
          }
          else {
            console.log('预约下载失败')
            // this.$message.error(res.data.msg);
          }
        })
        .catch(_ => {
        })
    },

    // 切换状态
    changeProgress(){
      if (this.progress !== 3) {
        this.progress += 1
      } else {
        this.progress = 1
      }
      if (this.progress === 2) {
        this.openQuery()
      } else {
        this.closeQuery()
      }
    },

    // 开启轮询
    openQuery() {
      this.queryProcess = setInterval(async () => {
        const params = this.getParams()
        let res = await axios.post(oprReqUrl+"/action/exportImage", params);
        if (res.data.code === 200) {
          this.changeProgress()
        }
        else if (res.data.code === 403) {
          // 进入下一次轮询
          // this.$message.error(res.data.msg);
        } else {
          // 出错了
          this.initProgress()
        }
      },3500)
    },

    // 结束轮询
    closeQuery() {
      clearInterval(this.queryProcess)
      this.queryProcess = null
    },

    // 初始化状态
    initProgress() {
      this.progress = 1
      this.closeQuery()
    },

    getParams() {
      this.filterData.start = this.filterData.date[0]
      this.filterData.end = this.filterData.date[1]
      this.filterData.posIds = this.filterData.posId ? this.filterData.posId.split(',') : []
      const params = _.assign(this.tableConfig, this.filterData )
      return params
    },

    statusFormatter(row){ //状态格式化
      switch (row.status) {
        case 'ok':
          return "完成"
          break;
        case 'progress':
          return "进行中"
          break;
        default:
          return "未知"
          break;
      }
    },
  }
};
</script>
<style lang="sass" scoped>
.activityManage
  input[type=file]
    display: none
  min-width: 1050px

  .activityManageBox
    padding: 20px

    .title
      color: #6F6F6F
      font-size: 26px
      font-weight: 600
      letter-spacing: 2px
      text-align: center
      margin-bottom: 30px

    .filter
      margin-top: 30px

    .label
      font-size: 14px
      color: #606266

    .table-container
      margin-top: 20px

  footer
    padding-top: 20px
    text-align: right

  .detailBox
    padding-top: 20px
    padding-bottom: 20px
    max-height: 400px
    overflow: auto
    .images
      display: flex
      img
        height: 150px
        margin-right: 10px
</style>



// WEBPACK FOOTER //
// src/opr/pages/views/activityManage.vue